<?php

define('CURRENT_TARGET', "web") ;
define('IMAGE_ASSET_PREFIX', '/') ;
define('CSS_ASSET_PREFIX', '/') ;
define('UNITER_BUILD_LEVEL', 'production') ;
define('REQUIRE_PREFIX', '.') ;
define('NAMESPACE_PREFIX', '') ;
define('VIEW_PREFIX', './') ;


// WEBPACK FOOTER //
// core/constants_uniter_prod.php